module.exports = __webpack_public_path__ + "img/header.3c5a8c01.png";